export const dishIngredientsData = [
  {
    id: 1,
    name: "pizza",
    data: [
      {
        id: 1,
        name: "thin-crust",
        header: "Thin Crust",
        imageLink: "thinCrust",
        group: "base",
        flag: "green",
      },
      {
        id: 2,
        name: "thick-crust",
        header: "Thick Crust",
        imageLink: "thickCrust",
        group: "base",
        flag: "red",
      },
      {
        id: 3,
        name: "alfredo-sauce",
        header: "Alfredo Sauce",
        imageLink: "alfredoSauce",
        group: "midlayer",
        flag: "red",
      },
      {
        id: 4,
        name: "tomato-sauce",
        header: "Tomato Sauce",
        imageLink: "tomatoSauce",
        group: "midlayer",
        flag: "green",
      },
      {
        id: 5,
        name: "light-cheese",
        header: "Light Cheese",
        imageLink: "lightCheese",
        group: "addon",
        flag: "green",
      },
      {
        id: 6,
        name: "heavy-cheese",
        header: "Heavy Cheese",
        imageLink: "heavyCheese",
        group: "addon",
        flag: "red",
      },
      {
        id: 7,
        name: "lean-grilled-chicken",
        header: "Lean Grilled Chicken",
        imageLink: "leanGrilledChicken",
        group: "extras",
        flag: "green",
      },
      {
        id: 8,
        name: "bacon",
        header: "Bacon",
        imageLink: "bacon",
        group: "extras",
        flag: "red",
      },
      {
        id: 9,
        name: "pepperoni",
        header: "Pepperoni",
        imageLink: "pepperoni",
        group: "extras",
        flag: "red",
      },
      {
        id: 10,
        name: "bell-pepper",
        header: "Bell Pepper",
        imageLink: "bellPepper",
        group: "extras",
        flag: "green",
      },
      {
        id: 11,
        name: "broccoli",
        header: "Broccoli",
        imageLink: "broccoli",
        group: "extras",
        flag: "green",
      },
      {
        id: 12,
        name: "gummy-bear",
        header: "Gummy Bear",
        imageLink: "gummyBear",
        group: "extras",
        flag: "red",
      },
    ],
  },
  {
    id: 2,
    name: "pasta",
    data: [
      {
        id: 1,
        name: "whole-wheat-pasta",
        header: "Whole Wheat Pasta",
        imageLink: "wholeWheatPasta",
        group: "base",
        flag: "green",
      },
      {
        id: 2,
        name: "white-pasta",
        header: "Regular White Pasta",
        imageLink: "whitePasta",
        group: "base",
        flag: "red",
      },
      {
        id: 3,
        name: "alfredo-sauce",
        header: "Alfredo Sauce",
        imageLink: "alfredoSauce",
        group: "midlayer",
        flag: "red",
      },
      {
        id: 4,
        name: "marinara-sauce",
        header: "Marinara Sauce",
        imageLink: "marinaraSauce",
        group: "midlayer",
        flag: "green",
      },
      {
        id: 5,
        name: "light-cheese",
        header: "Light Cheese",
        imageLink: "lightCheese",
        group: "addon",
        flag: "green",
      },
      {
        id: 6,
        name: "heavy-cheese",
        header: "Heavy Cheese",
        imageLink: "heavyCheese",
        group: "addon",
        flag: "red",
      },
      {
        id: 7,
        name: "lean-grilled-chicken",
        header: "Lean Grilled Chicken",
        imageLink: "leanGrilledChicken",
        group: "extras",
        flag: "green",
      },
      {
        id: 8,
        name: "pork-sausages",
        header: "Pork Sausages",
        imageLink: "porkSausages",
        group: "extras",
        flag: "red",
      },
      {
        id: 9,
        name: "bell-pepper",
        header: "Bell Pepper",
        imageLink: "bellPepper",
        group: "extras",
        flag: "green",
      },
      {
        id: 10,
        name: "meat-balls",
        header: "Meat Balls",
        imageLink: "meatBalls",
        group: "extras",
        flag: "red",
      },
      {
        id: 11,
        name: "butter",
        header: "Butter",
        imageLink: "butter",
        group: "extras",
        flag: "red",
      },
      {
        id: 12,
        name: "broccoli",
        header: "Broccoli",
        imageLink: "broccoli",
        group: "extras",
        flag: "green",
      },
    ],
  },
  {
    id: 3,
    name: "burger",
    data: [
      {
        id: 1,
        name: "whole-wheat-bun",
        header: "Whole Wheat Bun",
        imageLink: "wholeWheatBun",
        group: "base",
        flag: "green",
      },
      {
        id: 2,
        name: "white-bun",
        header: "Regular White Bun",
        imageLink: "whiteBun",
        group: "base",
        flag: "red",
      },
      {
        id: 3,
        name: "ground-beef-patty",
        header: "Ground Beef Patty",
        imageLink: "groundBeefPatty",
        group: "midlayer",
        flag: "red",
      },
      {
        id: 4,
        name: "black-bean-patty",
        header: "Black Bean Patty",
        imageLink: "blackBeanPatty",
        group: "midlayer",
        flag: "green",
      },
      {
        id: 5,
        name: "part-skim-mozzarella",
        header: "Part Skim Mozzarella",
        imageLink: "partSkimMozzarella",
        group: "addon",
        flag: "green",
      },
      {
        id: 6,
        name: "cheese-slices",
        header: "Cheese Slices",
        imageLink: "cheeseSlices",
        group: "addon",
        flag: "red",
      },
      {
        id: 7,
        name: "fresh-fruits",
        header: "Fresh Fruits",
        imageLink: "freshFruits",
        group: "extras",
        flag: "green",
      },
      {
        id: 8,
        name: "fried-french-fries",
        header: "Fried French Fries",
        imageLink: "friedFrenchFries",
        group: "extras",
        flag: "red",
      },
      {
        id: 9,
        name: "sweet-potato-fries",
        header: "Sweet Potato Fries",
        imageLink: "sweetPotatoFries",
        group: "extras",
        flag: "green",
      },
      {
        id: 10,
        name: "creamy-coleslaw",
        header: "Creamy Coleslaw",
        imageLink: "creamyColeslaw",
        group: "extras",
        flag: "red",
      },
      {
        id: 11,
        name: "steamed-veggies",
        header: "Steamed Veggies",
        imageLink: "steamedVeggies",
        group: "extras",
        flag: "green",
      },
      {
        id: 12,
        name: "mayonnaise",
        header: "Mayonnaise",
        imageLink: "mayonnaise",
        group: "extras",
        flag: "red",
      },
    ],
  },
  {
    id: 4,
    name: "smoothie",
    data: [
      {
        id: 1,
        name: "unsweetened-almond-milk",
        header: "Unsweetened Almond Milk",
        imageLink: "unsweetenedAlmondMilk",
        group: "base",
        flag: "green",
      },
      {
        id: 2,
        name: "sweetened-plant-milk",
        header: "Sweetened Plant Milk",
        imageLink: "sweetenedPlantMilk",
        group: "base",
        flag: "red",
      },
      {
        id: 3,
        name: "low-fat-plain-yogurt",
        header: "Low Fat Plain Yogurt",
        imageLink: "lowFatPlainYogurt",
        group: "midlayer",
        flag: "green",
      },
      {
        id: 4,
        name: "sugar-fruit-juices",
        header: "Sugar Fruit Juices",
        imageLink: "sugarFruitJuices",
        group: "midlayer",
        flag: "red",
      },
      {
        id: 5,
        name: "chocolate-bars",
        header: "Chocolate Bars",
        imageLink: "chocolateBars",
        group: "addon",
        flag: "red",
      },
      {
        id: 6,
        name: "berries",
        header: "Berries",
        imageLink: "berries",
        group: "addon",
        flag: "green",
      },
      {
        id: 7,
        name: "cut-brownies",
        header: "Cut Brownies",
        imageLink: "cutBrownies",
        group: "extras",
        flag: "red",
      },
      {
        id: 8,
        name: "veggies",
        header: "Veggies",
        imageLink: "veggies",
        group: "extras",
        flag: "green",
      },
      {
        id: 9,
        name: "chia-seeds",
        header: "Chia Seeds",
        imageLink: "chiaSeeds",
        group: "extras",
        flag: "green",
      },
      {
        id: 10,
        name: "whipped-cream",
        header: "Whipped Cream",
        imageLink: "whippedCream",
        group: "extras",
        flag: "red",
      },
      {
        id: 11,
        name: "flax-seeds",
        header: "Flax Seeds",
        imageLink: "flaxSeeds",
        group: "extras",
        flag: "green",
      },
      {
        id: 12,
        name: "waffer-biscuits",
        header: "Waffer Biscuits",
        imageLink: "wafferBiscuits",
        group: "extras",
        flag: "red",
      },
    ],
  },
];
